
import { Link } from "react-router-dom";

export default function BusinessCTA() {
  return (
    <section id="cta" className="py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
          对该业务感兴趣？
        </h2>
        <p className="text-lg text-white/80 mb-10 max-w-2xl mx-auto">
          我们的专家团队随时为您提供专业咨询与技术支持，欢迎联系我们了解更多详情
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/#contact"
            className="px-8 py-3.5 bg-white text-teal-700 text-sm font-semibold rounded-full hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
          >
            立即咨询
          </Link>
          <Link
            to="/"
            className="px-8 py-3.5 border-2 border-white/40 text-white text-sm font-semibold rounded-full hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </div>
    </section>
  );
}
